import { SVGAttributes } from 'react';

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
    return (
        <svg {...props} width="188" height="188" viewBox="0 0 188 188" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="188" height="188" rx="56" fill="var(--sidebar-primary)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.2663 54.0466C83.1844 53.9223 100.101 54.0466 117.015 54.4198C122.053 56.9711 123.421 60.827 121.12 65.9875C110.875 87.2249 100.426 108.37 89.7749 129.424C88.4831 131.004 86.8661 132.123 84.9239 132.782C69.0027 133.28 53.0815 133.28 37.1603 132.782C31.8119 130.667 29.9461 126.811 31.563 121.214C41.9658 100.16 52.1654 79.0145 62.1616 57.7782C63.4525 56.3588 64.8207 55.1149 66.2663 54.0466Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M131.195 80.9137C134.929 80.604 138.039 81.8479 140.524 84.6452C146.101 97.1468 151.823 109.585 157.689 121.961C158.678 126.321 157.31 129.68 153.584 132.036C140.448 133.248 127.264 133.498 114.03 132.782C109.311 130.684 107.445 127.076 108.433 121.961C114.26 109.706 120.23 97.5164 126.344 85.3915C127.772 83.6329 129.39 82.1402 131.195 80.9137Z"
                fill="#9196EA"
            />
            <defs>
                <linearGradient id="paint0_linear_10_22" x1="94" y1="0" x2="94" y2="188" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4A50E2" />
                    <stop offset="1" stopColor="#3C43E3" />
                </linearGradient>
            </defs>
        </svg>
    );
    return (
        <svg {...props} viewBox="0 0 40 42" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.2 5.63325L8.6 0.855469L0 5.63325V32.1434L16.2 41.1434L32.4 32.1434V23.699L40 19.4767V9.85547L31.4 5.07769L22.8 9.85547V18.2999L17.2 21.411V5.63325ZM38 18.2999L32.4 21.411V15.2545L38 12.1434V18.2999ZM36.9409 10.4439L31.4 13.5221L25.8591 10.4439L31.4 7.36561L36.9409 10.4439ZM24.8 18.2999V12.1434L30.4 15.2545V21.411L24.8 18.2999ZM23.8 20.0323L29.3409 23.1105L16.2 30.411L10.6591 27.3328L23.8 20.0323ZM7.6 27.9212L15.2 32.1434V38.2999L2 30.9666V7.92116L7.6 11.0323V27.9212ZM8.6 9.29991L3.05913 6.22165L8.6 3.14339L14.1409 6.22165L8.6 9.29991ZM30.4 24.8101L17.2 32.1434V38.2999L30.4 30.9666V24.8101ZM9.6 11.0323L15.2 7.92117V22.5221L9.6 25.6333V11.0323Z"
            />
        </svg>
    );
}
